<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div class="col-md-16 px-3 py-3 mb-5">
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('createPentest')"></h1>
            <h1 class="title">
              <span
                v-text="$ml.get('pentestCreateSubTitle')"
                class="pb-2"
              ></span>
            </h1>

            <div
              v-if="
                !['owner', 'administrator'].includes(
                  this.$store.getters['getUser'].role,
                )
              "
              class="card mb-3"
            >
              <div class="card-header">Opss...</div>
              <div class="card-body">
                <div class="d-flex justify-content-center">
                  <h2 class="size-1_4 p-3" v-text="$ml.get('viewersCannotCreatePentest')">
                    Usuários do tipo visualizador não tem permissão para criar
                    pentest !
                  </h2>
                </div>
              </div>
            </div>

            <font v-else>
              <div class="mb-3">
                <div class="d-column flex-row">
                  <div
                    class="h-form h-profile-lg d-flex flex-column pb-3 align-items-center no"
                  >
                    <!-- Configurações Tipo de Pentest -->
                    <config
                      @getInitialDate="getInitialDate"
                      @getFinalDate="getFinalDate"
                      @getTypePentest="getTypePentest"
                      @getRetest="getRetest"
                      @getLocation="getLocation"
                      @getSourceCode="getSourceCode"
                      @getAccessCredentials="getAccessCredentials"
                      @getListProfile="getListProfile"
                      :error="errorConfig"
                      number="1"
                    />

                    <!-- Escopo -->
                    <Scope
                      number="2"
                      @getListScop="getListScop"
                      :error="error_scope"
                    />
                    <!--Sobre-->
                    <about
                      number="3"
                      @getSummaryPentest="getSummaryPentest"
                      @getAboutCriticalApplication="getAboutCriticalApplication"
                      @getAboutHandleLargeVolumes="getAboutHandleLargeVolumes"
                      @getAboutFinancialTransactions="
                        getAboutFinancialTransactions
                      "
                      :error="summaryError"
                    />

                    <!-- Concluir -->
                    <div class="d-flex align-self-start">
                      <div
                        class="position-relative align-self-center d-flex align-items-center align-self-center"
                      >
                        <div
                          class="circle-number d-flex justify-content-center align-items-center"
                        >
                          <span>4</span>
                        </div>
                      </div>
                      <div class="pl-3 d-flex">
                        <div class="align-self-start">
                          <h2 class="size-1_4 m-0 pb-1">
                            <strong v-text="$ml.get('conclude')"
                              >Concluir</strong
                            >
                          </h2>
                          <p class="d-flex align-items-center">
                            <span
                              class="align-self-center"
                              v-text="$ml.get('haveYouRevised')"
                            >
                              Revisou seu programa? Então pronto!
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile">
                      <div class="v-line d-flex align-items-stretch">
                        <span class="pb-4"></span>
                      </div>
                    </div>

                    <div class="d-flex align-self-start h-profile-circle">
                      <div class="circle d-flex justify-content-center">
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-pending"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span class="pb-5"></span></div>
                      </div>

                      <div class="pl-3 d-flex w-100 align-items-center">
                        <div>
                          <div class="d-flex justify-content-center mb-2">
                            <RecaptchaV2
                              ref="recaptcha"
                              @verify="setRecaptchToken"
                              @expired="tokenRecaptcha = ''"
                            />
                          </div>
                          <button
                            @click="validateForm()"
                            :disabled="!tokenRecaptcha"
                            class="btn"
                            v-text="$ml.get('submitForReview')"
                          >
                            Enviar para Análise
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </font>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import $ from "jquery";
import Swal from "sweetalert2";

import About from "../../../components/company/program/about_pentest.vue";
import Config from "../../../components/company/program/config_pentest.vue";
import Scope from "../../../components/company/program/scope_pentest.vue";
import RecaptchaV2 from "../../../components/recaptchaV2.vue";
import pentestService from "../../../services/pentest.service";

export default {
  name: "Pentest",

  components: {
    Config,
    About,
    Scope,
    RecaptchaV2,
  },

  data() {
    return {
      initialDate: null,
      finalDate: null,
      type: "whitebox",
      retest: false,

      aboutCriticalApplication: false,
      aboutHandleLargeVolumes: false,
      aboutFinancialTransactions: false,

      accessCredentials: false,
      sourceCode: false,

      listScope: [],
      listProfile: [],

      location: "remote",

      summary: "",

      tokenRecaptcha: "",

      errorConfig: {
        initialDate: false,
        finalDate: false,
        perfil: false
      },
      error_scope: false,
      summaryError: false,
    };
  },

  methods: {
    getInitialDate(data) {
      this.initialDate = data ?? null;
    },
    getFinalDate(data) {
      this.finalDate = data ?? null;
    },
    getTypePentest(data) {
      this.type = data;
    },
    getRetest(data) {
      this.retest = data ?? false;
    },
    getListProfile(data) {
      this.listProfile = data ?? [];
    },
    getAccessCredentials(data) {
      this.accessCredentials = data ?? false;
    },
    getSourceCode(data) {
      this.sourceCode = data ?? false;
    },
    getLocation(data) {
      this.location = data;
    },
    getSummaryPentest(data) {
      this.summary = data ?? "";
    },
    getAboutCriticalApplication(data) {
      this.aboutCriticalApplication = data;
    },
    getAboutHandleLargeVolumes(data) {
      this.aboutHandleLargeVolumes = data;
    },
    getAboutFinancialTransactions(data) {
      this.aboutFinancialTransactions = data;
    },
    getListScop(data) {
      this.listScope = data ?? [];
    },
    setRecaptchToken(token) {
      this.tokenRecaptcha = token;
    },

    validateForm() {
      this.errorConfig.initialDate = false;
      this.errorConfig.finalDate = false;
      this.errorConfig.perfil = false;
      this.error_scope = false;
      this.summaryError = false;

      if (!this.initialDate) {
        this.errorConfig.initialDate = true;
      }

      if (!this.finalDate) {
        this.errorConfig.finalDate = true;
      }
      if (!this.listProfile.length) {
        this.errorConfig.perfil = true;
      }

      if (!this.listScope.length) {
        this.error_scope = true;
      }
      if (!this.summary) {
        this.summaryError = true;
      }

      if (!this.initialDate || !this.finalDate || !this.listScope.length) {
        this.$refs.recaptcha.resetRecaptcha();
        $("html, body").animate({ scrollTop: 0 }, "5000");

        return Swal.fire({
          icon: "warning",
          title: this.$ml.get("fillInAllFieldHighlightedInRed"),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }

      this.savePentest();
    },

    async savePentest() {
      try {
        const formData = new FormData();

        formData.append("initialDate", this.initialDate);
        formData.append("finalDate", this.finalDate);
        formData.append("type", this.type);
        formData.append("applicationLocation", this.location);
        formData.append("reTest", this.retest);
        formData.append("profiles", JSON.stringify(this.listProfile));
        formData.append("scope", JSON.stringify(this.listScope));
        formData.append("tokenRecaptcha", this.tokenRecaptcha);
        formData.append("aboutDescription", this.summary);
        formData.append(
          "aboutCriticalApplication",
          this.aboutCriticalApplication,
        );
        formData.append(
          "aboutHandleLargeVolumes",
          this.aboutHandleLargeVolumes,
        );
        formData.append(
          "aboutFinancialTransactions",
          this.aboutFinancialTransactions,
        );

        if (this.type === "whitebox") {
          formData.append("accessCredentials", this.accessCredentials);
          formData.append("sourceCode", this.sourceCode);
        }

        const { status } = await pentestService.postPentest(formData);
        if (status === 201) {
          Swal.fire({
            icon: "success",
            title: this.$ml.get("swalSendPentest"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
          this.$router.push("/pentest");
        }
      } catch (error) {
        this.$refs.recaptcha.resetRecaptcha();
        if(error.response.data.message[0] === 'A data inicial deve ser igual ou maior que a data atual!'){
          Swal.fire({
              icon: "warning",
              title: this.$ml.get("startDateMustBeEqualOrGreaterThanCurrent"),
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            }); 
        }
      }
    },
  },
};
</script>
<style>
.avatar-wrapper {
  height: 85px;
  width: 85px;
}

.editor-toolbar {
  border: 0px !important;
}

body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown),
html.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
  height: 100% !important;
  overflow-y: visible !important;
}
</style>
